import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useLanguage } from '../contexts/LanguageContext';
import { Card } from './ui/card';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Label } from './ui/label';
import { Timer, Save } from 'lucide-react';
import { toast } from 'sonner';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Admin control for the hard time cap on regular (non-psychology) calls.
export const AdminCallSettingsView = () => {
  const { t } = useLanguage();
  const [minutes, setMinutes] = useState('');
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    axios.get(`${API}/settings/call-limit`)
      .then((r) => setMinutes(String(r.data?.consult_call_minutes ?? 3)))
      .catch(() => toast.error(t('فشل التحميل', 'Failed to load')));
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const save = async () => {
    setSaving(true);
    try {
      const r = await axios.put(
        `${API}/admin/settings/call-limit`,
        { consult_call_minutes: Number(minutes) },
        { withCredentials: true },
      );
      setMinutes(String(r.data.consult_call_minutes));
      toast.success(t('تم الحفظ', 'Saved'));
    } catch (e) {
      toast.error(e?.response?.data?.detail || t('فشل الحفظ', 'Save failed'));
    } finally {
      setSaving(false);
    }
  };

  return (
    <Card className="p-5 space-y-4" data-testid="admin-call-settings-view">
      <h3 className="font-bold text-[#0d47a1] flex items-center gap-2">
        <Timer size={18} /> {t('مدة المكالمة', 'Consultation time limit')}
      </h3>
      <p className="text-sm text-gray-600">
        {t(
          'المدة القصوى لكل مكالمة عادية مع الطبيب أو الصيدلي. تُغلق المكالمة تلقائياً بعد انتهاء المدة. الجلسات النفسية غير مشمولة (تتبع مدة الحزمة).',
          'Maximum length of every regular doctor / pharmacist call. The call closes itself when the time is up. Psychology sessions are excluded — they follow their package length.',
        )}
      </p>
      <div className="flex items-end gap-3">
        <div className="w-40">
          <Label>{t('الدقائق', 'Minutes')}</Label>
          <Input
            type="number"
            min={1}
            max={120}
            value={minutes}
            onChange={(e) => setMinutes(e.target.value)}
            className="mt-1"
            data-testid="call-limit-minutes-input"
          />
        </div>
        <Button
          onClick={save}
          disabled={saving}
          className="bg-[#1565c0] hover:bg-[#0d47a1]"
          data-testid="call-limit-save-btn"
        >
          <Save size={14} className="me-1" />
          {saving ? t('جاري الحفظ...', 'Saving...') : t('حفظ', 'Save')}
        </Button>
      </div>
      <p className="text-xs text-gray-400">
        {t('ينطبق على المكالمات الجديدة فقط.', 'Applies to new calls only.')}
      </p>
    </Card>
  );
};

export default AdminCallSettingsView;
